export function sanitizeName(raw: string | undefined | null) {
  if (!raw && raw !== "") return "";
  const value = String(raw || "");
  // Remove any HTML tags
  const stripped = value.replace(/<[^>]*>/g, "");
  // Trim and collapse whitespace
  return stripped.replace(/\s+/g, " ").trim();
}

export function escapeHtml(raw: string | undefined | null) {
  if (!raw && raw !== "") return "";
  return String(raw || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export default sanitizeName;
